var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.25C26.0711 23.25 27.75 21.5711 27.75 19.5C27.75 17.4289 26.0711 15.75 24 15.75C21.9289 15.75 20.25 17.4289 20.25 19.5C20.25 21.5711 21.9289 23.25 24 23.25Z",
    stroke: "#1B2559",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 33C16.5 28.8 19.8 25.5 24 25.5C28.2 25.5 31.5 28.8 31.5 33",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.94e8ad1a9fb5ec1e99ed109f551ded10.svg";
export { ForwardRef as ReactComponent };